module.exports = __webpack_public_path__ + "img/arrow_icon.a1a6a461.png";